import { createSlice } from "@reduxjs/toolkit";
import { ActuatorInfoType } from "../backend/taxguru/client/actuatorClient";

export type ApplicationState = {
    actuatorInfo: ActuatorInfoType | undefined;
};

const initialState: ApplicationState = {
    actuatorInfo: undefined,
};

export const applicationSlice = createSlice({
    name: "taxApp",
    initialState,
    reducers: {
        setActuatorInfo: (state, action) => {
            state.actuatorInfo = action.payload;
        },
    },
});

export const { setActuatorInfo } = applicationSlice.actions;

export default applicationSlice.reducer;
